import React, { useEffect, useContext } from "react"
import './404.scss';
import { getIdFromUrl, isBrowser } from "@/lib/utils";
import { navigate } from "gatsby-link";

const NotFoundPage = () => {
  const isProduct = isBrowser ? window.location.pathname.indexOf('product') >= 0 : false;

  if (isProduct) {
    navigate(`/dp#${getIdFromUrl()}/`)
    return null
  }

  return (<>404</>)
}

export default NotFoundPage
